import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { WfMdTransitionRoleLinkContainerModel } from "../../../../../../models";
import { BaseApiTemplateService, Core2Config } from "../../shared";

@Injectable({ providedIn: "root" })
export class WfMdTransitionRoleLinkService extends BaseApiTemplateService<WfMdTransitionRoleLinkContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.WF_PREFIX + "md/transition-role-links/backoffice-ep";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.WF_PREFIX + "md/transition-role-links/backoffice-ep";
    this.httpClient = http;
  }
}
